import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";

export enum IncrementalResetType {
  DoNotReset = 0,
  ResetEveryCalendarYear = 1,
  ResetEveryMonthInCalendarYear = 2,
  ResetEveryDayInCalendarYear = 3,
  ResetEveryFiscalYear = 4,
  ResetEveryMonthInFiscalYear = 5,
  ResetEveryDayInFiscalYear = 6,
}

export const IncrementalResetTypeVOptions = [
  {label: "Do not reset", value: IncrementalResetType.DoNotReset},
  {label: "Reset every calendar year", value: IncrementalResetType.ResetEveryCalendarYear},
  {label: "Reset every month in calendar year", value: IncrementalResetType.ResetEveryMonthInCalendarYear},
  {label: "Reset every day in calendar year", value: IncrementalResetType.ResetEveryDayInCalendarYear},
  {label: "Reset every fiscal year", value: IncrementalResetType.ResetEveryFiscalYear},
  {label: "Reset every month in fiscal year", value: IncrementalResetType.ResetEveryMonthInFiscalYear},
  {label: "Reset every day in fiscal year", value: IncrementalResetType.ResetEveryDayInFiscalYear},
];